<template>
  <div>
    <search-form @search="onSearch" :fields="['term', 'sender_type', 'private_message', 'inbox', 'date_range']"/>
    <div class="margin-top-2" v-if="showResult" tab="messages">
      <section class="search-tab-conversation-table-wrap">
        <ve-table
          :fixed-header="false"
          max-height="calc(100vh - 11.4rem)"          
          :columns="columns"
          :table-data="tableData"
          :border-around="false"         
        />
       
        <empty-state
          v-if="!uiFlags.message.isFetching && !messageRecords.length"
          :title="$t('SEARCH.EMPTY_STATE')"
        />
        <div v-if="uiFlags.message.isFetching" class="loader">
          <spinner />
          <span>{{ $t('SEARCH.SEARCHING_STATE') }}</span>
        </div>
      </section>
      
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { frontendURL } from 'dashboard/helper/URLHelper';
import timeMixin from 'dashboard/mixins/time';

import { VeTable } from 'vue-easytable';
import Spinner from 'shared/components/Spinner.vue';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import MessageContent from './MessageContent';
import SearchForm from './SearchForm';


export default {
  mixins: [timeMixin],
  components: {
    VeTable,
    Spinner,
    EmptyState,    
    MessageContent,
    SearchForm
  },
  data() {
    return {
      showResult: false,      
      termMessage: '',
    };
  },  
  computed: {
    ...mapGetters({
      messageRecords: 'conversationSearch/getMessageRecords',
      uiFlags: 'conversationSearch/getUIFlags'
    }),      
    tableData() {
      if (this.uiFlags.message.isFetching) {
        return [];
      }
      return this.messageRecords.map(item => {        
        return {
          ...item,          
          link: frontendURL(`accounts/${this.$route.params.accountId}/conversations/${item.conversation_id}?messageId=${item.id}`),          
        };
      });
    },
    columns() {
      return [
        {
          field: 'id',
          key: 'id',
          title: "#",
          fixed: 'left',
          align: this.isRTLView ? 'right' : 'left',         
          width: 90,
          renderBodyCell: ({ row }) => (
            <router-link
              to={row.link}
              class="user-name"
            >
              {row.id}
            </router-link>       
          ),          
        },
        {
          field: 'created_at',
          key: 'created_at',
          title: this.$t("SEARCH.LIST.HEADER.SEND_AT"),
          align: this.isRTLView ? 'right' : 'left',          
          width: 150,
          renderBodyCell: ({ row }) => {            
            return this.messageStamp(
              new Date(row.created_at),
              'dd/MM/yy - HH:mm'
            );
          },
        },
        {
          field: 'sender_by',
          key: 'sender_by',          
          title: this.$t("SEARCH.LIST.HEADER.SENDER_BY"),
          align: this.isRTLView ? 'right' : 'left',
          width: 260,
          renderBodyCell: ({ row }) => {
            let text = (row.sender_type === 'User' ? this.$t("SEARCH.LIST.HEADER.USER") : this.$t("SEARCH.LIST.HEADER.CLIENT")) + ': ';
            text += (row.sender ? row.sender.name : '---');
            return text;
          },  
        },
        {
          field: 'content',
          key: 'content',
          title: this.$t("SEARCH.LIST.HEADER.MESSAGE_CONTENT"),
          fixed: 'left',
          align: this.isRTLView ? 'right' : 'left',
          renderBodyCell: ({ row }) => (
            <message-content              
              content={row.content}
              search-term={this.termMessage}
            >
              {row.id}
            </message-content>       
          ),          
        },
        {
          field: 'inbox',
          key: 'inbox',          
          title: this.$t("SEARCH.LIST.HEADER.INBOX"),
          align: this.isRTLView ? 'right' : 'left',
          width: 260,
          renderBodyCell: ({ row }) => {            
            return (row.inbox ? row.inbox.name : '---');
          },  
        },
      ];
    }
  },
  methods: {
    onSearch(data) {      
      this.showResult = data !== null;
      if(!data || Object.keys(data).length == 0){
        this.$store.dispatch('conversationSearch/clearSearchResults', { type: 'message' });        
        return;
      }
      this.termMessage = data.term;
      this.$store.dispatch('conversationSearch/messageSearch', {
        term: data.term,
        sender_type: data.sender_type ? data.sender_type.id : null,
        private_message: data.private_message ? data.private_message.id : null,
        inbox: data.inbox ? data.inbox.id : null,
        start_date: data.tempDateRange[0].toISOString().split('T')[0],
        end_date: data.tempDateRange[1].toISOString().split('T')[0],
      });      
    },    
    onClickConversation(conversationId) {
      this.$router.push(`/app/accounts/${this.$route.params.accountId}/conversations/${conversationId}`);      
    }
  },
};
</script>
<style lang="scss" scoped> 
  .search-tab-conversation-table-wrap{
    .loader {
      align-items: center;
      display: flex;
      font-size: var(--font-size-default);
      justify-content: center;
      padding: var(--space-big);
    }
  }
</style>

